import { render, staticRenderFns } from "./stu_2LayoutBasic3.vue?vue&type=template&id=09b36b33&scoped=true"
import script from "./stu_2LayoutBasic3.vue?vue&type=script&lang=js"
export * from "./stu_2LayoutBasic3.vue?vue&type=script&lang=js"
import style0 from "./stu_2LayoutBasic3.vue?vue&type=style&index=0&id=09b36b33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b36b33",
  null
  
)

export default component.exports